
































































import Vue from 'vue';
import LOGO from '../../../config/LOGO.png';
import moment from 'moment';

// Services
import AnalyticService from '~/services/AnalyticService';
import SchoolService from '~/services/SchoolService';
import UserInfoService from '~/services/UserInfoService';
import { HIGHERED_CV_TEMPLATE } from '~/services/ResourceService';

// Project components
import MainLayout from '~/components/layouts/mainlayout/MainLayout.vue';
import VFairList from './components/VFairList.vue';
import CV from '~/assets/img/vcf/CV.jpg';
import MasterClass from '~/assets/img/vcf/Masterclass.jpg';
import ElevatorPitch from '~/assets/img/vcf/ElevatorPitch.jpg';
import LinkCard from './components/LinkCard.vue';
import Paper from '~/components/builders/Paper.vue';
import Footer from '../components/Footer.vue';
import { VFair } from '~/services/VFairService';
import Header from '~/components/layouts/Header.vue';

export default Vue.extend({
    name: 'FindVFairs',
    props: {
        suppressLogging: Boolean,
    },
    components: {
        MainLayout,
        VFairList,
        LinkCard,
        Paper,
        Footer,
        Header,
    },
    computed: {
        vfairs(): { data: VFair[]; loading: boolean } {
            return this.$interfaces.vfair.get({
                reactive: true,
            });
        },
        nextVFairTimeStamp(): Date {
            const data = this.data();
            if (data.length > 0) {
                return new Date(data[0].start);
            } else {
                return new Date(Date.now());
            }
        },
        hasVFairs(): boolean {
            return this.$interfaces.vfairModule.getHasVFairs();
        },
    },
    data() {
        return {
            cv: CV,
            elevatorPitch: ElevatorPitch,
            masterClass: MasterClass,
            cvTemplateLink: HIGHERED_CV_TEMPLATE,
            organizations: [],
            // companiesLoading: false,
            logo: LOGO,
            showHackGif: false,
            hackClicked: false,
            hackTrue: !!localStorage.getItem('vfair_hack'),
        };
    },
    methods: {
        data(): VFair[] {
            const isHigheredAdmin = UserInfoService.isHigheredAdmin();
            const theData = this.vfairs.data
                .filter(item => {
                    if (!isHigheredAdmin && !item.studentVisibility) {
                        return false;
                    }
                    let check = moment(item.start);
                    if (item.end) {
                        check = moment(item.end);
                    }
                    let now = moment();

                    // VFAIR HACK
                    // TODO: Remove this hack from 1th of March 2023!
                    if (
                        item.id === '4df18ac3-620f-4f43-8892-c84607e3928f' &&
                        SchoolService.getCurrentSchoolDomain() !== 'binorwegianbusinessschool'
                    ) {
                        return false;
                    }
                    // VFAIR HACK END

                    return item.active && now.isSameOrBefore(check);
                })
                .sort((a, b) => {
                    const momentA = moment(a.start);
                    const momentB = moment(b.start);
                    return momentA.isBefore(momentB) ? -1 : 1;
                });
            return theData;
        },
        loading(): boolean {
            return this.vfairs.loading;
        },
    },
    mounted() {
        AnalyticService.impressionEvent(AnalyticService.IMPRESSION_ACTIONS.VFAIRLIST_VIEW_ACTION);
        // Temporarily disabled
        // this.$interfaces.vfairs.organizations.get().then(orgs => {
        //     this.organizations = [];
        //     orgs.data.forEach(org => {
        //         if (
        //             org.status === 2 &&
        //             this.organizations.find(o => o.id == org.organizationId) === undefined
        //         ) {
        //             this.organizations.push({
        //                 id: org.organizationId,
        //                 logo: org.logo,
        //                 name: org.title,
        //             });
        //         }
        //     });
        //     this.companiesLoading = false;
        // });
    },
});
